import { render } from "@/components/pages/individualWorkSupport/requirement040/Requirement040.html?vue&type=template&id=1b21f8fb&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement040/Requirement040.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement040/Requirement040.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement040/Requirement040.scss?vue&type=style&index=0&id=1b21f8fb&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b21f8fb"]])

export default __exports__